import { Component, Input, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthService } from '../../access/auth.service';
import { AppComponent } from '../../app.component';
import { User } from '../../models/user';
import { FeatureBuilder, MenuFeature } from '../../services/feature-builder.service';
import { NotificationService } from '../../services/notification.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  providers: [AppComponent]
})
export class MenuComponent implements OnInit, OnDestroy {

  @Input() page: string | undefined;

  user: User | undefined;
  hasStore: boolean = false;
  hasSubsidiary: boolean = false;
  isAdmin: boolean = false;
  isManager = false;
  isMerkaoUser: boolean = false;
  features: MenuFeature[] = [];
  openMenu: string | null = null;

  unreadCount: number = 0;

  private destroy$ = new Subject<void>();

  constructor(
    private auth: AuthService,
    private _route: Router,
    private notificationService: NotificationService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.isAdmin = this.auth.isAdmin();
    this.isManager = this.auth.isManager();
    this.user = this.auth.getUser();
    this.isMerkaoUser = this.user.storeName === 'Merkao' ? true : false;
    this.hasStore = this.user.storeName ? true : false;
    this.hasSubsidiary = this.user.subsidiaryName ? true : false;
    this.features = new FeatureBuilder(this.user).build();

    this.initializeNotifications();
  }

  ngOnDestroy(): void {
    this.notificationService.stopAllPolling();
    this.destroy$.next();
    this.destroy$.complete();
  }

  private initializeNotifications(): void {
    if (!this.user?.userId || !this.user?.storeId) {
      return;
    }

    const storeId = this.auth.getStore()?.storeId || this.user.storeId;
    const userId = this.user.userId.toString();

    this.notificationService.unreadCount$
      .pipe(takeUntil(this.destroy$))
      .subscribe(count => {
        this.unreadCount = count;
        this.cdr.detectChanges();
      });

    this.notificationService.getUnreadCount(storeId, userId)
      .pipe(takeUntil(this.destroy$))
      .subscribe();

    this.notificationService.startPollingUnreadCount(storeId, userId, 18000); //3m
  }

  logout() {
    this.notificationService.stopAllPolling();
    this.notificationService.resetUnreadCount();
    this.auth.logout();
    this._route.navigate(['/public/sign/login']);
  }

  removeStore() {
    if (this.isAdmin) {
      if (this.auth.removeStore()) {
        this._route.navigate(['/members/store/listStore']);
      }
    }
  }

  removeSubsidiary() {
    if (this.isAdmin || this.isManager) {
      this.auth.removeSubsidiary();
      this._route.navigate(['/members/subsidiary/listSubsidiary']);
    }
  }
  toggleMenu(feature: MenuFeature) {
    if (!feature.children) {
      return;
    }
    this.openMenu = this.openMenu === feature.className ? null : feature.className;
  }
}